import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  AuthModule as OidcAuthModule,
  LogLevel,
  OidcSecurityService,
  OpenIdConfiguration,
  StsConfigHttpLoader,
  StsConfigLoader
} from 'angular-auth-oidc-client';
import { filter, map, switchMap, take, tap } from 'rxjs/operators';
import { DataShareService } from '../services/data-share.service';
import { AuthenticationService } from '@bo-client/core/authentication/authentication.service';

export function authFactory(dataShareService: DataShareService) {
  const config = dataShareService.tenantConfig$.pipe(
    filter((config) => !!config && !!config.iamConfig?.externalIdpEnabled),
    map((config) => config.iamConfig),
    map((config) => {
      return {
        configId: 'external-idp',
        authority: `${config.authorityUrl}`,
        authWellknownEndpointUrl: `${config.authWellknownEndpointUrl}`,
        clientId: config.clientId,
        redirectUrl: window.location.origin + (config.redirectUrlSuffix ?? '/hap-fe/bo/'),
        disableIdTokenValidation: true,
        postLogoutRedirectUri: window.location.origin + (config.redirectUrlSuffix ?? '/hap-fe/bo/'),
        scope: `${config.scope}`,
        responseType: 'code',
        silentRenew: false,
        ignoreNonceAfterRefresh: true,
        useRefreshToken: false,
        maxIdTokenIatOffsetAllowedInSeconds: 600,
        issValidationOff: true,
        logLevel: LogLevel.Debug,
        customParamsCodeRequest: config.clientSecret
          ? {
              client_secret: config.clientSecret
            }
          : {},
        customParamsAuthRequest: {
          prompt: 'login', // login, consent
          tsgClientId: dataShareService.currentTenant.id
        },
        autoUserInfo: false,
        triggerAuthorizationResultEvent: true
      } as OpenIdConfiguration;
    })
  );
  return new StsConfigHttpLoader(config);
}

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    OidcAuthModule.forRoot({
      loader: {
        provide: StsConfigLoader,
        useFactory: authFactory,
        deps: [DataShareService]
      }
    })
  ],
  exports: [OidcAuthModule]
})
/**
 * This module is used to handle the authentication process for the application.
 * It is used to exchange the IDP token for a local token.
 * The IDP token is received from the IDP login page.
 * The local token is used to authenticate the user to the application.
 */
export class AuthModule {
  constructor(private oidcSecurityService: OidcSecurityService, private authService: AuthenticationService) {
    // Subscribe to successful authentications
    const stateParam = sessionStorage.getItem('authState');
    sessionStorage.removeItem('authState');

    if (stateParam) {
      console.log('got state param invoking checkAuth', stateParam);
      this.oidcSecurityService
        .checkAuth(stateParam ? stateParam : undefined)
        .pipe(
          filter((auth) => !!auth.accessToken),
          take(1)
        )
        .subscribe((auth) => {
          console.log('getting a subscription event from checkAuth', auth);
          if (!!auth.accessToken) {
            this.authService
              .loginWithExternalToken({
                external_token: auth.accessToken,
                grant_type: 'token_exchange'
              })
              .subscribe();
          }
        });
    }
  }
}
